
import Flow from '@/components/block/Flow.vue'

export default {
  name: 'FlowDocumentRequest',

  props: {
    current: Number
  },

  components: {
    Flow
  },

  setup() {
    const items = [
      {
        label: '資料請求申込み',
        current: false
      },
      {
        label: '申込み内容の確認',
        current: false
      },
      {
        label: '申込み完了',
        current: false
      }
    ]

    return {
      items
    }
  }
}
